/**
 * Derive Slack attention ticket + refs from linkedTicketKey and free text.
 */

import { extractJiraTicketKeys } from '@zunelo/shared';
import type { CrossReference, SlackThread } from './types';

function slackTextCorpus(thread: SlackThread): Array<string | undefined> {
  return [
    thread.linkedTicketKey,
    thread.aiSummary?.summary,
    thread.zuneloMeta?.ai,
    ...(thread.messages ?? []).map((message) => message.text),
  ];
}

export function resolveSlackTicketAndRefs(thread: SlackThread): {
  ticket?: string;
  refs?: CrossReference[];
} {
  const keys = extractJiraTicketKeys(...slackTextCorpus(thread));
  const ticket = thread.linkedTicketKey?.trim() || keys[0];
  const merged = thread.zuneloMeta?.refs?.length
    ? [...thread.zuneloMeta.refs]
    : keys.map((key, index) => ({
        key,
        grade: (index === 0 ? 'explícita' : 'inferida') as CrossReference['grade'],
        why: index === 0 ? 'Detectado en el hilo' : 'También mencionado en el hilo',
      }));
  if (!ticket && merged.length === 0) return {};
  return {
    ticket,
    refs: merged.length > 0 ? merged : undefined,
  };
}
